import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Stack,
  useMediaQuery,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../Api/ApiUrls';
import img1 from './../../../Images/vendorcard.jpg';
import FormsBottomNavbar from './FormsBottomNavbar';
import SearchBar from './PostBack';
import { AuthContext } from '../../AuthContext/AuthContext';

// Array of form navigation options
const options = [
  {
    leftLabel: "Best",
    rightLabel: "Deals",
    centerText: "New Launching Properties\n(Layouts, Villas, Apartment Flats)", 
    path: "/postyourbestdeal-form"
  },
  {
    leftLabel: "   ",
    rightLabel: "   ",
    centerText: "Sell Your Property",
    path: "/sellyourproperty-form"
  },
  {
    leftLabel: "   ",
    rightLabel: "   ",
    centerText: "Rent Your Property",
    path: "/rent-form"
  },
  {
    leftLabel: "   ",
    rightLabel: "   ",
    centerText: "Lease Your Property",
    path: "/lease-form"
  },
  {
    leftLabel: "   ",
    rightLabel: "   ",
    centerText: "Post your JD/JV/Build Suit",
    path: "/builder-registration-form"
  },
  {
    leftLabel: "   ",
    rightLabel: "   ",
    centerText: "Post Your Requirements",
    path: "/pg-hostel-form"
  },
  {
    leftLabel: "   ",
    rightLabel: "   ",
    centerText: "Post bank action Properties",
    path: "/post-bank-properties"
  },
];

const Forms = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isiPhoneSE = useMediaQuery('(max-width: 376px) and (max-height: 670px)');
  const isSmallScreen = useMediaQuery('(max-width: 376px)');
  const cardHeight = isSmallScreen ? 60 : 65;

  const navigate = useNavigate();

  // ✅ STATE
  const [openModal, setOpenModal] = useState(false);
  const [missingPlans, setMissingPlans] = useState([]);
  const { userId, logout, isGuest } = useContext(AuthContext);

  const handleBackClick = () => navigate(-1);

  // ✅ CHECK FREE PLAN API
  useEffect(() => {
    checkFreePlan();
  }, []);

  const checkFreePlan = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/check-free-plan/${userId}/`
      );

      if (!res.data.has_free_plan) {
        setMissingPlans(res.data.missing_free_user_types || []);
        setOpenModal(true);
      }
    } catch (error) {
      console.error("Error checking free plan:", error);
    }
  };

  // ✅ CLAIM API
const handleClaim = async () => {
  try {
    await axios.post(
      `${BASE_URL}/claim-all-free-plans/`,
      {
        user_id: userId,
      }
    );

    alert("✅ Free plans claimed successfully!");

    // ✅ Close modal
    setOpenModal(false);

    // optional re-check
    checkFreePlan();

  } catch (error) {
    console.error("Error claiming free plans:", error);
  }
};

  return (
    <>
      <SearchBar onBackClick={handleBackClick} />

      <Box
        sx={{
          px: 2,
          pt: 10,
          pb: 10,
          maxWidth: '100%',
          mx: 'auto',
          minHeight: isiPhoneSE ? '100vh' : '82vh', // ✅ Conditional height
          backgroundImage: 'url(/Forms.png)', // ✅ Public folder image
          backgroundColor: '#f5f5f5', // ✅ Fallback background
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Stack spacing={3}>
          {options.map((item, index) => (
            <Box key={index} onClick={() => navigate(item.path)} sx={{ cursor: 'pointer' }}>
              <Paper
                elevation={4}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  bgcolor: '#D6C0B3',
                  height: cardHeight, // ✅ Responsive card height
                  borderTopLeftRadius: '40px',
                  borderBottomRightRadius: '40px',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.03)',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                  },
                }}
              >
                {item.leftLabel && (
                  <Box
                    sx={{
                      width: 40,
                      height: '99%',
                      bgcolor: '#343a40',
                      color: '#fff',
                      writingMode: 'vertical-rl',
                      transform: 'rotate(180deg)',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                      fontWeight: 600,
                      borderTopRightRadius: '5px',
                      borderBottomRightRadius: '40px',
                    }}
                  >
                    {item.leftLabel}
                  </Box>
                )}

                <Typography
                  sx={{
                    flexGrow: 1,
                    textAlign: 'center',
                    whiteSpace: 'pre-line',
                    fontWeight: 600,
                    fontSize: isMobile ? '14px' : '16px',
                    color: '#333',
                  }}
                >
                  {item.centerText}
                </Typography>

                {item.rightLabel && (
                  <Box
                    sx={{
                      width: 40,
                      height: '100%',
                      bgcolor: '#343a40',
                      color: '#fff',
                      writingMode: 'vertical-rl',
                      transform: 'rotate(180deg)',
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                      fontWeight: 600,
                      borderBottomLeftRadius: '5px',
                      borderTopLeftRadius: '40px',
                    }}
                  >
                    {item.rightLabel}
                  </Box>
                )}
              </Paper>
            </Box>
          ))}

          {/* ✅ Vendor Registration Section */}
          <Box onClick={() => navigate('/vendor-form')} sx={{ cursor: 'pointer' }}>
            <Paper
              elevation={4}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: '#D6C0B3',
                height: cardHeight, // ✅ Responsive height
                borderTopLeftRadius: '40px',
                borderBottomRightRadius: '40px',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.03)',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                },
              }}
            >
              {/* Avatar and Text */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexGrow: 1,
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Avatar
                    src={img1}
                    alt="Vendor"
                    sx={{
                      width: 55,
                      height: 55,
                      border: '2px solid #fff',
                    }}
                  />
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    ml: 5,
                    fontWeight: 600,
                    fontSize: isMobile ? '14px' : '18px',
                    color: '#333',
                  }}
                >
                  Vendors Registration
                </Typography>
              </Box>

              {/* ✅ Right Label - Fixed to show empty space properly */}
              <Box
                sx={{
                  width: 40,
                  height: '100%',
                  bgcolor: '#343a40',
                  color: '#fff',
                  writingMode: 'vertical-rl',
                  transform: 'rotate(180deg)',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 600,
                  borderBottomLeftRadius: '5px',
                  borderTopLeftRadius: '40px',
                }}
              >
                {"   "}
              </Box>
            </Paper>
          </Box>
        </Stack>
      </Box>

     {/* <Dialog
  open={openModal}
  onClose={() => setOpenModal(false)}
  fullWidth
  maxWidth="sm"
  PaperProps={{
    sx: {
      borderRadius: 4,
      overflow: "hidden"
    }
  }}
>

  <Box
    sx={{
      background: "linear-gradient(135deg, #1976d2, #42a5f5)",
      color: "#fff",
      p: 3,
      textAlign: "center"
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 700 }}>
      🎉 Free Subscription Available
    </Typography>
    <Typography variant="body2" sx={{ opacity: 0.9 }}>
      Claim your free plans instantly
    </Typography>
  </Box>

 
  <DialogContent sx={{ px: 3, py: 2 }}>
    <Typography sx={{ mb: 2, textAlign: "center" }}>
      You have some free offers waiting. Don’t miss them!
    </Typography>

    {missingPlans.length > 0 && (
      <Stack spacing={1.5}>
        {missingPlans.map((item, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              p: 1.5,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              border: "1px solid #e0e0e0",
              backgroundColor: "#f9fbff"
            }}
          >
            <Avatar
              sx={{
                width: 30,
                height: 30,
                bgcolor: "#1976d2",
                fontSize: 14
              }}
            >
              🎁
            </Avatar>

            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
              {item}
            </Typography>
          </Paper>
        ))}
      </Stack>
    )}
  </DialogContent>


  <DialogActions
    sx={{
      px: 3,
      pb: 2,
      display: "flex",
      justifyContent: "space-between"
    }}
  >
    <Button
      variant="outlined"
      onClick={() => handleClaim(false)}
      sx={{
        borderRadius: 2,
        textTransform: "none",
        px: 3
      }}
    >
      Skip & Claim Later
    </Button>

    <Button
      variant="contained"
      onClick={() => handleClaim(true)}
      sx={{
        borderRadius: 2,
        textTransform: "none",
        px: 3,
        fontWeight: 600,
        background: "linear-gradient(135deg, #1976d2, #42a5f5)"
      }}
    >
      🚀 Claim Now
    </Button>
  </DialogActions>
</Dialog> */}

      <FormsBottomNavbar />
    </>
  );
};

export default Forms;